import APIClient from '@/shared/http/clients/api'

const resourceName = 'TipoObra'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)
const GetTipoObraByNome = (nome, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/getByNome/${nome}`, config)

const WorkTypeRepository = {
  GetAll,
  GetTipoObraByNome
}
export default WorkTypeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/worktype.js